import { useMemo } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { buildColumnDefs } from './columnFactory';
// import { defaultComponents, defaultComponentsProps } from '@/grid/toolbar';

export default function ThirdFloorDataGrid( { gridKey, schema, registry, rows, overrides } ) {
    const columns = useMemo( () => {
        return buildColumnDefs( gridKey, schema, registry );
    }, [ gridKey, schema, registry ] );

    return (
        <DataGridPro
            columns={ typeof( schema.cols ) === 'object' ? schema.cols : columns }
            rows={rows}
            {...overrides}
            // slots={defaultComponents}
            // slotProps={defaultComponentsProps}
            disableColumnMenu
            density="compact"
        />
    );
}